
export enum OverviewChartPeriods {
    year = 365,
    month = 30,
    week = 7,
    today = 1
  }